
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as new8qs2sGMD1B9jI50m7Z6ooJaiOb4npyBbZpSb9cbY1oAMeta } from "/app/pages/admin/dynamic/new.vue?macro=true";
import { default as newzsWS9Lw0p4sKZI3UFx5MecTSIZfkL0kjaHEWkyEVE2EMeta } from "/app/pages/admin/markets/new.vue?macro=true";
import { default as indexVtBy8YS0JPKMILJfrvDWNOew04uRA2cZdmiE2JIA34UMeta } from "/app/pages/admin/dynamic/index.vue?macro=true";
import { default as indexO7Oo5PW8MJT_IV45b3VL1p21Z4T2Q_Qxcz9tWulA8_45AMeta } from "/app/pages/admin/markets/index.vue?macro=true";
import { default as _91name_93Mvl8pGEto3yaO4FVuFO6S6N9aIvVJzOlTya7eVdfsukMeta } from "/app/pages/admin/markets/[name].vue?macro=true";
import { default as _91_46_46_46slug_93BC5gQ4Fn6HmYlfYohUlIDVym8uxtGyrGSCUENSN1_451QMeta } from "/app/pages/admin/dynamic/[...slug].vue?macro=true";
import { default as adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta } from "/app/pages/admin.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as globusnLbC_tMqYpo0l4WLGv7rkOCtXOZwX15GX30lI8OwQCkMeta } from "/app/pages/globus.vue?macro=true";
import { default as searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta } from "/app/pages/search.vue?macro=true";
import { default as discordq5dBaC_45wkOjT8bCwNk2mdbG8qsb7YL3JvfzlAEyohWYMeta } from "/app/pages/discord.vue?macro=true";
import { default as pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta } from "/app/pages/pricing.vue?macro=true";
import { default as indexPYMehh1H3I51I_Jt_45B2w91jhAIWvwCrr7OI55V5sjLcMeta } from "/app/pages/profile/index.vue?macro=true";
import { default as billingVo7aVrxpiBadh_45dHWGu44cjMEo3cLduXhiTZSqi1lsYMeta } from "/app/pages/profile/billing.vue?macro=true";
import { default as services2vK7qRHPDb7V4evPzec08_eDbL72XRqa2qDethwpDHwMeta } from "/app/pages/profile/services.vue?macro=true";
import { default as statisticsidtjB3_qVzey0kk2fpGsOhsFGfFcWoCcHz5oWxvcZEEMeta } from "/app/pages/profile/statistics.vue?macro=true";
import { default as profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta } from "/app/pages/profile.vue?macro=true";
import { default as trade_45up16qcid_7q7f8mRYBc2g2yIzMF7WpXjiaOio8Ltp0O8kMeta } from "/app/pages/trade-up.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta } from "/app/pages/comparison.vue?macro=true";
import { default as _91id_93sdOp6pY5CZ0uXIhNptifuJohX5f24FjTRdqPuYADSKEMeta } from "/app/pages/teams/[id].vue?macro=true";
import { default as _91id_93fZahOkxSaUDDzs7F8lWVdTvFbSqLFZwVScSwODyHNDIMeta } from "/app/pages/colors/[id].vue?macro=true";
import { default as indexAptcgaIc_rPBy3bcUzAEO8ZFeJoskT3pNgSmyxfzK7MMeta } from "/app/pages/teams/index.vue?macro=true";
import { default as indexyR_zl8X35KYNEAK_QjVjJ5UuR3fAW5hzzUs_45cWrQlhMMeta } from "/app/pages/colors/index.vue?macro=true";
import { default as _91id_93izFvCnWcgHAY_ts6g8T4Pa5ypVJq0i8HVOtbn1tKXYwMeta } from "/app/pages/weapons/[id].vue?macro=true";
import { default as indexsBrZcisz7ifHbTcHjlicMzT8apHna2uVYCHGw0AJrpoMeta } from "/app/pages/markets/index.vue?macro=true";
import { default as _91id_938axNa8DjBfDBwGv9kVopGpm4TjQieimHgWslTm2N3KEMeta } from "/app/pages/inventory/[id].vue?macro=true";
import { default as _91name_93dFqkCHGU8GHehR4wtZnWaAcd_NtS5F_6w2ji7Zo4__45MMeta } from "/app/pages/markets/[name].vue?macro=true";
import { default as indexEMqZjQk1JFj_U3n2jrtSsSh3msCiBmySQU2mufszfWwMeta } from "/app/pages/inventory/index.vue?macro=true";
import { default as _91id_93t_45aLuZ9c4UDYBxpS3zHGtIPCD1j0fymLpxckKGdmsKgMeta } from "/app/pages/collections/[id].vue?macro=true";
import { default as _91id_93ntRifX_451GzHL_45xnCMtWTU0FyXdDHZ46nCGC7NJMRla0Meta } from "/app/pages/pro-players/[id].vue?macro=true";
import { default as _91category_93za_V_454AyV81NP2Vy4bRosPMxcdhDLIGxDaNX9IkI8cAMeta } from "/app/pages/tournaments/[id]/[category].vue?macro=true";
import { default as _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta } from "/app/pages/tournaments/[id].vue?macro=true";
import { default as indexQ5DiAbwu_45Z3qN8kuNqB2OS3uSCjo_NPcA4tlOyZmPSgMeta } from "/app/pages/collections/index.vue?macro=true";
import { default as indexC2uyEyjxtg0UU5zGbDGwX2VTL1sn4iTK5fkVQbDQ5qoMeta } from "/app/pages/item/[name]/index.vue?macro=true";
import { default as index5HivNzNgF9qZ_becrIDz0i93LuYUQaNyGVWyLZXP3doMeta } from "/app/pages/tournaments/index.vue?macro=true";
import { default as _91_46_46_46slug_93VndChygzO8UB_hJySUXtS6lcoyfZbCGxni9bme2HnP4Meta } from "/app/pages/bargains/[...slug].vue?macro=true";
import { default as newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta } from "/app/pages/blog/moderation/new.vue?macro=true";
import { default as index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta } from "/app/pages/blog/[category]/index.vue?macro=true";
import { default as indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta } from "/app/pages/blog/moderation/index.vue?macro=true";
import { default as index0j0yU16RK69767E3zEPhMF1UJBwf6vJ8UQshnvtkm_0Meta } from "/app/pages/containers/[id]/index.vue?macro=true";
import { default as _91exterior_93SANvhzv_45E5d3drxhidt63RywKOAfP5Wc_psC6FyP3lAMeta } from "/app/pages/item/[name]/[exterior].vue?macro=true";
import { default as _91category_93Asl_454T_45RIABfRXGVNT2dD1yyPgASJOUHOcUc1FpEtJUMeta } from "/app/pages/weapons/all/[category].vue?macro=true";
import { default as indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta } from "/app/pages/blog/[category]/[link]/index.vue?macro=true";
import { default as index9z3ikOcqa0lOkC1pOKD4vVWUUZ7bBMmfD4YmaBMTbiIMeta } from "/app/pages/containers/[id]/rare-items/index.vue?macro=true";
import { default as indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta } from "/app/pages/blog/moderation/edit/[category]/index.vue?macro=true";
import { default as _91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta } from "/app/pages/blog/moderation/edit/[category]/[link].vue?macro=true";
export default [
  {
    name: "admin___ch",
    path: "/ch/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___ch",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___ch",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___ch",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___ch",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___ch",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___ch",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___da",
    path: "/da/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___da",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___da",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___da",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___da",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___da",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___da",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___de",
    path: "/de/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___de",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___de",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___de",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___de",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___de",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___de",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___en",
    path: "/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___en",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___en",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___en",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___en",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___en",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___en",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___es",
    path: "/es/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___es",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___es",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___es",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___es",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___es",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___es",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___fr",
    path: "/fr/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___fr",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___fr",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___fr",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___fr",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___fr",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___fr",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___nl",
    path: "/nl/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___nl",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___nl",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___nl",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___nl",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___nl",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___nl",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___pl",
    path: "/pl/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___pl",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___pl",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___pl",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___pl",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___pl",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___pl",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___pt",
    path: "/pt/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___pt",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___pt",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___pt",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___pt",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___pt",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___pt",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___ro",
    path: "/ro/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___ro",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___ro",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___ro",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___ro",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___ro",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___ro",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___ru",
    path: "/ru/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___ru",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___ru",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___ru",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___ru",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___ru",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___ru",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___sv",
    path: "/sv/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___sv",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___sv",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___sv",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___sv",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___sv",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___sv",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___tr",
    path: "/tr/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___tr",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___tr",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___tr",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___tr",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___tr",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___tr",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "admin___uk",
    path: "/uk/admin",
    meta: { ...(adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-dynamic-new___uk",
    path: "dynamic/new",
    component: () => import("/app/pages/admin/dynamic/new.vue")
  },
  {
    name: "admin-markets-new___uk",
    path: "markets/new",
    component: () => import("/app/pages/admin/markets/new.vue")
  },
  {
    name: "admin-dynamic___uk",
    path: "dynamic",
    component: () => import("/app/pages/admin/dynamic/index.vue")
  },
  {
    name: "admin-markets___uk",
    path: "markets",
    component: () => import("/app/pages/admin/markets/index.vue")
  },
  {
    name: "admin-markets-name___uk",
    path: "markets/:name()",
    component: () => import("/app/pages/admin/markets/[name].vue")
  },
  {
    name: "admin-dynamic-slug___uk",
    path: "dynamic/:slug(.*)*",
    component: () => import("/app/pages/admin/dynamic/[...slug].vue")
  }
]
  },
  {
    name: "index___ch",
    path: "/ch",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___da",
    path: "/da",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___sv",
    path: "/sv",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "globus___ch",
    path: "/ch/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___da",
    path: "/da/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___de",
    path: "/de/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___en",
    path: "/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___es",
    path: "/es/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___fr",
    path: "/fr/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___nl",
    path: "/nl/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___pl",
    path: "/pl/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___pt",
    path: "/pt/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___ro",
    path: "/ro/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___ru",
    path: "/ru/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___sv",
    path: "/sv/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___tr",
    path: "/tr/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "globus___uk",
    path: "/uk/globus",
    meta: {"middleware":["admin"]},
    component: () => import("/app/pages/globus.vue")
  },
  {
    name: "search___ch",
    path: "/ch/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___da",
    path: "/da/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___es",
    path: "/es/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___nl",
    path: "/nl/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___pl",
    path: "/pl/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___pt",
    path: "/pt/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___ro",
    path: "/ro/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___ru",
    path: "/ru/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___sv",
    path: "/sv/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___tr",
    path: "/tr/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___uk",
    path: "/uk/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "discord___ch",
    path: "/ch/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___da",
    path: "/da/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___de",
    path: "/de/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___en",
    path: "/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___es",
    path: "/es/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___fr",
    path: "/fr/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___nl",
    path: "/nl/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___pl",
    path: "/pl/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___pt",
    path: "/pt/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___ro",
    path: "/ro/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___ru",
    path: "/ru/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___sv",
    path: "/sv/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___tr",
    path: "/tr/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "discord___uk",
    path: "/uk/discord",
    component: () => import("/app/pages/discord.vue")
  },
  {
    name: "pricing___ch",
    path: "/ch/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___da",
    path: "/da/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___de",
    path: "/de/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___en",
    path: "/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___es",
    path: "/es/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___fr",
    path: "/fr/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___nl",
    path: "/nl/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___pl",
    path: "/pl/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___pt",
    path: "/pt/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___ro",
    path: "/ro/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___ru",
    path: "/ru/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___sv",
    path: "/sv/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___tr",
    path: "/tr/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___uk",
    path: "/uk/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/ch/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___ch",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___ch",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___ch",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___ch",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/da/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___da",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___da",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___da",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___da",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/de/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___de",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___de",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___de",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___de",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___en",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___en",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___en",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___en",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/es/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___es",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___es",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___es",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___es",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/fr/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___fr",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___fr",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___fr",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___fr",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/nl/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___nl",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___nl",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___nl",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___nl",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/pl/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___pl",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___pl",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___pl",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___pl",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/pt/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___pt",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___pt",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___pt",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___pt",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/ro/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___ro",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___ro",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___ro",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___ro",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/ru/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___ru",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___ru",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___ru",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___ru",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/sv/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___sv",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___sv",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___sv",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___sv",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/tr/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___tr",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___tr",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___tr",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___tr",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta?.name,
    path: "/uk/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/profile.vue"),
    children: [
  {
    name: "profile___uk",
    path: "",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile-billing___uk",
    path: "billing",
    component: () => import("/app/pages/profile/billing.vue")
  },
  {
    name: "profile-services___uk",
    path: "services",
    component: () => import("/app/pages/profile/services.vue")
  },
  {
    name: "profile-statistics___uk",
    path: "statistics",
    component: () => import("/app/pages/profile/statistics.vue")
  }
]
  },
  {
    name: "trade-up___ch",
    path: "/ch/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___da",
    path: "/da/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___de",
    path: "/de/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___en",
    path: "/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___es",
    path: "/es/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___fr",
    path: "/fr/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___nl",
    path: "/nl/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___pl",
    path: "/pl/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___pt",
    path: "/pt/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___ro",
    path: "/ro/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___ru",
    path: "/ru/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___sv",
    path: "/sv/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___tr",
    path: "/tr/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "trade-up___uk",
    path: "/uk/trade-up",
    component: () => import("/app/pages/trade-up.vue")
  },
  {
    name: "blog___ch",
    path: "/ch/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___da",
    path: "/da/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___es",
    path: "/es/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___nl",
    path: "/nl/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___pl",
    path: "/pl/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___pt",
    path: "/pt/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___ro",
    path: "/ro/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___ru",
    path: "/ru/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___sv",
    path: "/sv/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___tr",
    path: "/tr/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___uk",
    path: "/uk/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "comparison___ch",
    path: "/ch/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___da",
    path: "/da/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___de",
    path: "/de/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___en",
    path: "/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___es",
    path: "/es/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___fr",
    path: "/fr/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___nl",
    path: "/nl/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___pl",
    path: "/pl/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___pt",
    path: "/pt/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___ro",
    path: "/ro/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___ru",
    path: "/ru/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___sv",
    path: "/sv/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___tr",
    path: "/tr/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "comparison___uk",
    path: "/uk/comparison",
    meta: comparisonNnftZGCq9aGCwfxLbi6BFlGFhySykgBKzL1n6R5SrUkMeta || {},
    component: () => import("/app/pages/comparison.vue")
  },
  {
    name: "teams-id___ch",
    path: "/ch/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___da",
    path: "/da/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___de",
    path: "/de/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___en",
    path: "/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___es",
    path: "/es/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___fr",
    path: "/fr/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___nl",
    path: "/nl/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___pl",
    path: "/pl/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___pt",
    path: "/pt/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___ro",
    path: "/ro/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___ru",
    path: "/ru/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___sv",
    path: "/sv/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___tr",
    path: "/tr/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "teams-id___uk",
    path: "/uk/teams/:id()",
    component: () => import("/app/pages/teams/[id].vue")
  },
  {
    name: "colors-id___ch",
    path: "/ch/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___da",
    path: "/da/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___de",
    path: "/de/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___en",
    path: "/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___es",
    path: "/es/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___fr",
    path: "/fr/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___nl",
    path: "/nl/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___pl",
    path: "/pl/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___pt",
    path: "/pt/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___ro",
    path: "/ro/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___ru",
    path: "/ru/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___sv",
    path: "/sv/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___tr",
    path: "/tr/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "colors-id___uk",
    path: "/uk/colors/:id()",
    component: () => import("/app/pages/colors/[id].vue")
  },
  {
    name: "teams___ch",
    path: "/ch/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___da",
    path: "/da/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___de",
    path: "/de/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___en",
    path: "/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___es",
    path: "/es/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___fr",
    path: "/fr/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___nl",
    path: "/nl/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___pl",
    path: "/pl/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___pt",
    path: "/pt/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___ro",
    path: "/ro/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___ru",
    path: "/ru/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___sv",
    path: "/sv/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___tr",
    path: "/tr/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "teams___uk",
    path: "/uk/teams",
    component: () => import("/app/pages/teams/index.vue")
  },
  {
    name: "colors___ch",
    path: "/ch/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___da",
    path: "/da/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___de",
    path: "/de/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___en",
    path: "/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___es",
    path: "/es/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___fr",
    path: "/fr/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___nl",
    path: "/nl/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___pl",
    path: "/pl/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___pt",
    path: "/pt/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___ro",
    path: "/ro/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___ru",
    path: "/ru/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___sv",
    path: "/sv/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___tr",
    path: "/tr/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "colors___uk",
    path: "/uk/colors",
    component: () => import("/app/pages/colors/index.vue")
  },
  {
    name: "weapons-id___ch",
    path: "/ch/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___da",
    path: "/da/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___de",
    path: "/de/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___en",
    path: "/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___es",
    path: "/es/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___fr",
    path: "/fr/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___nl",
    path: "/nl/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___pl",
    path: "/pl/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___pt",
    path: "/pt/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___ro",
    path: "/ro/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___ru",
    path: "/ru/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___sv",
    path: "/sv/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___tr",
    path: "/tr/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "weapons-id___uk",
    path: "/uk/weapons/:id()",
    component: () => import("/app/pages/weapons/[id].vue")
  },
  {
    name: "markets___ch",
    path: "/ch/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___da",
    path: "/da/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___de",
    path: "/de/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___en",
    path: "/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___es",
    path: "/es/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___fr",
    path: "/fr/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___nl",
    path: "/nl/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___pl",
    path: "/pl/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___pt",
    path: "/pt/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___ro",
    path: "/ro/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___ru",
    path: "/ru/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___sv",
    path: "/sv/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___tr",
    path: "/tr/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "markets___uk",
    path: "/uk/markets",
    component: () => import("/app/pages/markets/index.vue")
  },
  {
    name: "inventory-id___ch",
    path: "/ch/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___da",
    path: "/da/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___de",
    path: "/de/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___en",
    path: "/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___es",
    path: "/es/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___fr",
    path: "/fr/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___nl",
    path: "/nl/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___pl",
    path: "/pl/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___pt",
    path: "/pt/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___ro",
    path: "/ro/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___ru",
    path: "/ru/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___sv",
    path: "/sv/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___tr",
    path: "/tr/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "inventory-id___uk",
    path: "/uk/inventory/:id()",
    component: () => import("/app/pages/inventory/[id].vue")
  },
  {
    name: "markets-name___ch",
    path: "/ch/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___da",
    path: "/da/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___de",
    path: "/de/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___en",
    path: "/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___es",
    path: "/es/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___fr",
    path: "/fr/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___nl",
    path: "/nl/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___pl",
    path: "/pl/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___pt",
    path: "/pt/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___ro",
    path: "/ro/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___ru",
    path: "/ru/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___sv",
    path: "/sv/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___tr",
    path: "/tr/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "markets-name___uk",
    path: "/uk/markets/:name()",
    component: () => import("/app/pages/markets/[name].vue")
  },
  {
    name: "inventory___ch",
    path: "/ch/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___da",
    path: "/da/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___de",
    path: "/de/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___en",
    path: "/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___es",
    path: "/es/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___fr",
    path: "/fr/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___nl",
    path: "/nl/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___pl",
    path: "/pl/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___pt",
    path: "/pt/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___ro",
    path: "/ro/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___ru",
    path: "/ru/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___sv",
    path: "/sv/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___tr",
    path: "/tr/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "inventory___uk",
    path: "/uk/inventory",
    component: () => import("/app/pages/inventory/index.vue")
  },
  {
    name: "collections-id___ch",
    path: "/ch/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___da",
    path: "/da/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___de",
    path: "/de/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___en",
    path: "/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___es",
    path: "/es/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___fr",
    path: "/fr/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___nl",
    path: "/nl/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___pl",
    path: "/pl/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___pt",
    path: "/pt/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___ro",
    path: "/ro/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___ru",
    path: "/ru/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___sv",
    path: "/sv/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___tr",
    path: "/tr/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "collections-id___uk",
    path: "/uk/collections/:id()",
    component: () => import("/app/pages/collections/[id].vue")
  },
  {
    name: "pro-players-id___ch",
    path: "/ch/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___da",
    path: "/da/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___de",
    path: "/de/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___en",
    path: "/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___es",
    path: "/es/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___fr",
    path: "/fr/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___nl",
    path: "/nl/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___pl",
    path: "/pl/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___pt",
    path: "/pt/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___ro",
    path: "/ro/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___ru",
    path: "/ru/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___sv",
    path: "/sv/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___tr",
    path: "/tr/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "pro-players-id___uk",
    path: "/uk/pro-players/:id()",
    component: () => import("/app/pages/pro-players/[id].vue")
  },
  {
    name: "tournaments-id___ch",
    path: "/ch/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___ch",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___da",
    path: "/da/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___da",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___de",
    path: "/de/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___de",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___en",
    path: "/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___en",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___es",
    path: "/es/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___es",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___fr",
    path: "/fr/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___fr",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___nl",
    path: "/nl/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___nl",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___pl",
    path: "/pl/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___pl",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___pt",
    path: "/pt/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___pt",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___ro",
    path: "/ro/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___ro",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___ru",
    path: "/ru/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___ru",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___sv",
    path: "/sv/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___sv",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___tr",
    path: "/tr/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___tr",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "tournaments-id___uk",
    path: "/uk/tournaments/:id()",
    meta: _91id_93qBV3hqpuk2Yf3270XxYipRKesczBtODBUP40YojomqoMeta || {},
    component: () => import("/app/pages/tournaments/[id].vue"),
    children: [
  {
    name: "tournaments-id-category___uk",
    path: ":category()",
    component: () => import("/app/pages/tournaments/[id]/[category].vue")
  }
]
  },
  {
    name: "collections___ch",
    path: "/ch/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___da",
    path: "/da/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___de",
    path: "/de/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___en",
    path: "/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___es",
    path: "/es/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___fr",
    path: "/fr/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___nl",
    path: "/nl/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___pl",
    path: "/pl/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___pt",
    path: "/pt/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___ro",
    path: "/ro/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___ru",
    path: "/ru/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___sv",
    path: "/sv/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___tr",
    path: "/tr/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "collections___uk",
    path: "/uk/collections",
    component: () => import("/app/pages/collections/index.vue")
  },
  {
    name: "item-name___ch",
    path: "/ch/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___da",
    path: "/da/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___de",
    path: "/de/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___en",
    path: "/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___es",
    path: "/es/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___fr",
    path: "/fr/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___nl",
    path: "/nl/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___pl",
    path: "/pl/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___pt",
    path: "/pt/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___ro",
    path: "/ro/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___ru",
    path: "/ru/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___sv",
    path: "/sv/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___tr",
    path: "/tr/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "item-name___uk",
    path: "/uk/item/:name()",
    component: () => import("/app/pages/item/[name]/index.vue")
  },
  {
    name: "tournaments___ch",
    path: "/ch/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___da",
    path: "/da/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___de",
    path: "/de/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___en",
    path: "/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___es",
    path: "/es/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___fr",
    path: "/fr/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___nl",
    path: "/nl/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___pl",
    path: "/pl/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___pt",
    path: "/pt/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___ro",
    path: "/ro/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___ru",
    path: "/ru/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___sv",
    path: "/sv/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___tr",
    path: "/tr/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___uk",
    path: "/uk/tournaments",
    component: () => import("/app/pages/tournaments/index.vue")
  },
  {
    name: "bargains-slug___ch",
    path: "/ch/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___da",
    path: "/da/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___de",
    path: "/de/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___en",
    path: "/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___es",
    path: "/es/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___fr",
    path: "/fr/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___nl",
    path: "/nl/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___pl",
    path: "/pl/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___pt",
    path: "/pt/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___ro",
    path: "/ro/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___ru",
    path: "/ru/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___sv",
    path: "/sv/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___tr",
    path: "/tr/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "bargains-slug___uk",
    path: "/uk/bargains/:slug(.*)*",
    component: () => import("/app/pages/bargains/[...slug].vue")
  },
  {
    name: "blog-moderation-new___ch",
    path: "/ch/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___da",
    path: "/da/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___de",
    path: "/de/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___en",
    path: "/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___es",
    path: "/es/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___fr",
    path: "/fr/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___nl",
    path: "/nl/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___pl",
    path: "/pl/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___pt",
    path: "/pt/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___ro",
    path: "/ro/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___ru",
    path: "/ru/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___sv",
    path: "/sv/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___tr",
    path: "/tr/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-moderation-new___uk",
    path: "/uk/blog/moderation/new",
    meta: { ...(newxrmfwmd12DFa_456Bof2Gu_45X43mvD_458zh5nbwQEu3gC4cMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/new.vue")
  },
  {
    name: "blog-category___ch",
    path: "/ch/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___da",
    path: "/da/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___de",
    path: "/de/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___en",
    path: "/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___es",
    path: "/es/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___fr",
    path: "/fr/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___nl",
    path: "/nl/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___pl",
    path: "/pl/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___pt",
    path: "/pt/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___ro",
    path: "/ro/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___ru",
    path: "/ru/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___sv",
    path: "/sv/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___tr",
    path: "/tr/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-category___uk",
    path: "/uk/blog/:category()",
    meta: index8h7OnJBAasHno4cFdiLZzeiJ97Z4_47VNBUq184lzrIMeta || {},
    component: () => import("/app/pages/blog/[category]/index.vue")
  },
  {
    name: "blog-moderation___ch",
    path: "/ch/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___da",
    path: "/da/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___de",
    path: "/de/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___en",
    path: "/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___es",
    path: "/es/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___fr",
    path: "/fr/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___nl",
    path: "/nl/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___pl",
    path: "/pl/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___pt",
    path: "/pt/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___ro",
    path: "/ro/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___ru",
    path: "/ru/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___sv",
    path: "/sv/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___tr",
    path: "/tr/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "blog-moderation___uk",
    path: "/uk/blog/moderation",
    meta: { ...(indexWFbSsewmF1br21ruEZSrH1O3h2XlOiscKrSiThUO7qkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/index.vue")
  },
  {
    name: "containers-id___ch",
    path: "/ch/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___da",
    path: "/da/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___de",
    path: "/de/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___en",
    path: "/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___es",
    path: "/es/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___fr",
    path: "/fr/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___nl",
    path: "/nl/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___pl",
    path: "/pl/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___pt",
    path: "/pt/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___ro",
    path: "/ro/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___ru",
    path: "/ru/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___sv",
    path: "/sv/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___tr",
    path: "/tr/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "containers-id___uk",
    path: "/uk/containers/:id()",
    component: () => import("/app/pages/containers/[id]/index.vue")
  },
  {
    name: "item-name-exterior___ch",
    path: "/ch/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___da",
    path: "/da/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___de",
    path: "/de/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___en",
    path: "/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___es",
    path: "/es/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___fr",
    path: "/fr/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___nl",
    path: "/nl/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___pl",
    path: "/pl/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___pt",
    path: "/pt/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___ro",
    path: "/ro/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___ru",
    path: "/ru/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___sv",
    path: "/sv/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___tr",
    path: "/tr/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "item-name-exterior___uk",
    path: "/uk/item/:name()/:exterior()",
    component: () => import("/app/pages/item/[name]/[exterior].vue")
  },
  {
    name: "weapons-all-category___ch",
    path: "/ch/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___da",
    path: "/da/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___de",
    path: "/de/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___en",
    path: "/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___es",
    path: "/es/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___fr",
    path: "/fr/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___nl",
    path: "/nl/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___pl",
    path: "/pl/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___pt",
    path: "/pt/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___ro",
    path: "/ro/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___ru",
    path: "/ru/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___sv",
    path: "/sv/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___tr",
    path: "/tr/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "weapons-all-category___uk",
    path: "/uk/weapons/all/:category()",
    component: () => import("/app/pages/weapons/all/[category].vue")
  },
  {
    name: "blog-category-link___ch",
    path: "/ch/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___da",
    path: "/da/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___de",
    path: "/de/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___en",
    path: "/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___es",
    path: "/es/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___fr",
    path: "/fr/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___nl",
    path: "/nl/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___pl",
    path: "/pl/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___pt",
    path: "/pt/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___ro",
    path: "/ro/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___ru",
    path: "/ru/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___sv",
    path: "/sv/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___tr",
    path: "/tr/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "blog-category-link___uk",
    path: "/uk/blog/:category()/:link()",
    meta: indexzbosGnC_45nZqb7P6Rr_45DjRkquS45J2lIy8KJL_HrYctYMeta || {},
    component: () => import("/app/pages/blog/[category]/[link]/index.vue")
  },
  {
    name: "containers-id-rare-items___ch",
    path: "/ch/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___da",
    path: "/da/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___de",
    path: "/de/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___en",
    path: "/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___es",
    path: "/es/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___fr",
    path: "/fr/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___nl",
    path: "/nl/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___pl",
    path: "/pl/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___pt",
    path: "/pt/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___ro",
    path: "/ro/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___ru",
    path: "/ru/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___sv",
    path: "/sv/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___tr",
    path: "/tr/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "containers-id-rare-items___uk",
    path: "/uk/containers/:id()/rare-items",
    component: () => import("/app/pages/containers/[id]/rare-items/index.vue")
  },
  {
    name: "blog-moderation-edit-category___ch",
    path: "/ch/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___da",
    path: "/da/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___de",
    path: "/de/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___en",
    path: "/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___es",
    path: "/es/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___fr",
    path: "/fr/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___nl",
    path: "/nl/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___pl",
    path: "/pl/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___pt",
    path: "/pt/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___ro",
    path: "/ro/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___ru",
    path: "/ru/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___sv",
    path: "/sv/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___tr",
    path: "/tr/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category___uk",
    path: "/uk/blog/moderation/edit/:category()",
    meta: { ...(indexrlNJVNyutvbZrsQEkt1SwLss9zZr1_45EO0DjAsggoA3oMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/index.vue")
  },
  {
    name: "blog-moderation-edit-category-link___ch",
    path: "/ch/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___da",
    path: "/da/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___de",
    path: "/de/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___en",
    path: "/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___es",
    path: "/es/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___fr",
    path: "/fr/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___nl",
    path: "/nl/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___pl",
    path: "/pl/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___pt",
    path: "/pt/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___ro",
    path: "/ro/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___ru",
    path: "/ru/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___sv",
    path: "/sv/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___tr",
    path: "/tr/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  },
  {
    name: "blog-moderation-edit-category-link___uk",
    path: "/uk/blog/moderation/edit/:category()/:link()",
    meta: { ...(_91link_93hypwkNoWvi4yji2_45GH1li3gl4_45CH6vTyqpea7clwhXwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/blog/moderation/edit/[category]/[link].vue")
  }
]